'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _uniq3 = require('lodash/uniq');

var _uniq4 = _interopRequireDefault(_uniq3);

var _assign3 = require('lodash/assign');

var _assign4 = _interopRequireDefault(_assign3);

var _map3 = require('lodash/map');

var _map4 = _interopRequireDefault(_map3);

var _keyBy3 = require('lodash/keyBy');

var _keyBy4 = _interopRequireDefault(_keyBy3);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

exports.findIndexInObjectByKw = findIndexInObjectByKw;
exports.filterObjectsByKw = filterObjectsByKw;
exports.filterObjectsByKws = filterObjectsByKws;
exports.mergeObjectArraysByKey = mergeObjectArraysByKey;
exports.stopEvent = stopEvent;
exports.isIOS = isIOS;
exports.secondsToTime = secondsToTime;
exports.customEvent = customEvent;
exports.popupWindowCenter = popupWindowCenter;

var _strings = require('helpers/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import xregexp from 'xregexp';


function findIndexInObjectByKw(object, fields) {
  var kw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var foundIndex = 0;

  if (kw) {
    foundIndex = -1;
    fields.map(function (field) {
      var index = (0, _strings.cleanString)((0, _get4.default)(object, field, '')).indexOf(kw);
      if (index !== -1) {
        if (foundIndex === -1) {
          foundIndex = index;
        }
        foundIndex = Math.min(foundIndex, index);
      }
    });
  }

  return foundIndex;
}

function filterObjectsByKw(objects, fields) {
  var kw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var firstMatches = [];
  var lastMatches = [];
  var clearKw = (0, _strings.cleanString)(kw);

  objects.map(function (object) {
    var foundIndex = findIndexInObjectByKw(object, fields, clearKw);
    if (foundIndex === 0) {
      firstMatches.push(object);
    } else if (foundIndex > 0) {
      lastMatches.push(object);
    }
  });

  return [].concat(firstMatches, lastMatches);
}

function filterObjectsByKws(_ref) {
  var objects = _ref.objects,
      fields = _ref.fields,
      _ref$kw = _ref.kw,
      kw = _ref$kw === undefined ? '' : _ref$kw;

  var firstMatches = [];
  var lastMatches = [];
  // parse keywords string to array of uniq words
  // xregexp to support Unicode
  // const regexp = xregexp('[\\pL]{1,}', 'igm');
  // const regexp = new RegExp(/[\w]{1,}/igm);
  // const kws = _uniq((kw.match(regexp) || []).map(kwPart => cleanString(kwPart)));

  // split words by special characters - works with utf8 but not so universal as split by words
  var splitRegex = new RegExp(/[ ,\.\(\):@"'\\/?!#№$;%^&*\[\]=\+\-_~`<>]{1,}/igm); // eslint-disable-line no-useless-escape
  var kws = (0, _uniq4.default)(kw.split(splitRegex).map(function (kwPart) {
    return (0, _strings.cleanString)(kwPart);
  }));

  if (!kws.length) {
    return objects;
  }

  objects.map(function (object) {
    var foundIndexes = [];
    kws.map(function (kwPart) {
      var foundIndex = findIndexInObjectByKw(object, fields, kwPart);
      if (foundIndex > -1) {
        foundIndexes.push(foundIndex);
      }
    });

    // only if all keywords found in object fields
    if (foundIndexes.length === kws.length) {
      var firstFoundIndex = foundIndexes.sort()[0];
      if (firstFoundIndex === 0) {
        firstMatches.push(object);
      } else if (firstFoundIndex > 0) {
        lastMatches.push(object);
      }
    }
  });

  return [].concat(firstMatches, lastMatches);
}

function mergeObjectArraysByKey(key) {
  var normalizedArrays = [];

  for (var _len = arguments.length, arrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  arrays.map(function (array) {
    normalizedArrays.push((0, _keyBy4.default)([].concat((0, _toConsumableArray3.default)(array)), key));
  });
  return (0, _map4.default)(_assign4.default.apply(undefined, normalizedArrays));
}

function stopEvent(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  return e;
}

function isIOS() {
  return typeof navigator !== 'undefined' && (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i));
}

function secondsToTime(_ref2) {
  var seconds = _ref2.seconds,
      _ref2$separator = _ref2.separator,
      separator = _ref2$separator === undefined ? ':' : _ref2$separator,
      _ref2$infinityStr = _ref2.infinityStr,
      infinityStr = _ref2$infinityStr === undefined ? 'calculating...' : _ref2$infinityStr;

  if (seconds === Infinity) {
    return infinityStr;
  }
  var hour = Math.floor(seconds / 3600);
  var min = Math.floor((seconds - hour * 3600) / 60);
  var sec = seconds - hour * 3600 - min * 60;
  var timeToStr = function timeToStr(time) {
    return ('0' + time).substr(-2);
  };
  var res = timeToStr(min) + separator + timeToStr(sec);
  return hour ? hour + separator + res : res;
}

function customEvent(name, data) {
  if (typeof window === 'undefined') {
    return false;
  }

  function CustomEventPolyfill(event, params) {
    var evParams = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, evParams.bubbles, evParams.cancelable, evParams.detail);
    return evt;
  }

  if (typeof window.CustomEvent !== 'function') {
    CustomEventPolyfill.prototype = window.Event.prototype;
    window.CustomEvent = CustomEventPolyfill;
  }
  return new window.CustomEvent(name, { detail: data });
}

function popupWindowCenter(url, title, windowWidth, windowHeight) {
  if (typeof window === 'undefined') {
    return false;
  }

  // Fixes dual-screen position                                       Most browsers      Firefox
  var dualScreenLeft = typeof window.screenLeft !== 'undefined' ? window.screenLeft : screen.left;
  var dualScreenTop = typeof window.screenTop !== 'undefined' ? window.screenTop : screen.top;

  var _document$documentEle = document.documentElement,
      clientWidth = _document$documentEle.clientWidth,
      clientHeight = _document$documentEle.clientHeight;

  var width = window.innerWidth ? window.innerWidth : clientWidth || screen.width;
  var height = window.innerHeight ? window.innerHeight : clientHeight || screen.height;

  var left = width / 2 - windowWidth / 2 + dualScreenLeft;
  var top = height / 2 - windowHeight / 2 + dualScreenTop;
  var windowProps = 'scrollbars=yes, width=' + windowWidth + ', height=' + windowHeight + ', top=' + top + ', left=' + left + ', menubar=no, toolbar=no, location=no';
  var newWindow = window.open(url, title, windowProps);

  // Puts focus on the newWindow
  if (window.focus) {
    newWindow.focus();
  }

  return newWindow;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/utils.js
// module id = 24
// module chunks = 1